import "./report.scss";
import { observer } from "mobx-react";
import { useEffect, useMemo } from "react";
import { IReportFiltersType, REPORT_TYPES } from "../../services/api/report-service";
import ReportStore from "../../stores/report-store";
import IconDownload from "../icons/icon-download/icon-download";
import { BUTTON_VARIANTS } from "../inputs/button-variants";
import { Button } from "../inputs/button/button";
import ReportLinkTitle from "./components/last-report-link/last-report-link";
import FontBody1 from "../fonts/font-body1/font-body1";
import { FONT_COLOR } from "../fonts/font-props";
import DashTranslation from "../../dashboard-translation/dashboard-translaton";

interface IReportProps {
    type: REPORT_TYPES;
    title: string;
    getReportFilters?: () => IReportFiltersType;
}

const Report: React.FC<IReportProps> = observer(({ title, type, getReportFilters }) => {
    const store = useMemo<ReportStore>(() => new ReportStore(type, getReportFilters), [type, getReportFilters]);

    useEffect(() => {
        store.load();
    }, [store]);

    return (
        <div className="report-container">
            <Button
                hasLoader
                isLoading={store.isGenerating}
                disabled={store.isLoading}
                leftIcon={IconDownload}
                text={title}
                variant={BUTTON_VARIANTS.Secondary}
                onClick={store.generateReport}
            />
            <div className="report-link-container">
                {store.lastGenerated ? (
                    <ReportLinkTitle
                        dateString={store.lastGenerated.updated_at}
                        link={store.lastGenerated.file_path}
                    />
                ) : (
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                        <DashTranslation translationKey={'NOT_DOWNLOADED_YET'} scope="dashboard-general" />
                    </FontBody1>
                )}
            </div>
        </div>
    );
});

export default Report;
